module.exports = __webpack_public_path__ + "static/media/436F206E-7187-4781-ABF3-9BFA98D63C58.fc198f6e.jpeg";